module.exports = __webpack_public_path__ + "img/expand-down.043d3ef8.svg";